import React from 'react';
import styled from 'styled-components';
import Btn from './btn';
import { changeState, translate, setSelectedOption } from '../help/functions';
import { SelectProps } from '../help/interfaces';

export const Select: React.FC<SelectProps> = ({
  onlyRewrapped,
  conditionSelected,
  setConditionSelected,
  parsedQs,
  history,
}) => {
  if (onlyRewrapped) {
    return null;
  }

  return (
    <Component>
      <ConditionSelected>
        escolha a condição: <b>{translate[conditionSelected]}</b>
      </ConditionSelected>
      <Btn
        value="new"
        conditionSelected={conditionSelected}
        setConditionSelected={changeState(setConditionSelected, setSelectedOption(parsedQs, history))}
      />
      <Btn
        value="rewrapped"
        conditionSelected={conditionSelected}
        setConditionSelected={changeState(setConditionSelected, setSelectedOption(parsedQs, history))}
      />
    </Component>
  );
};

const Component = styled.div`
  @media (min-width: 700px) {
    margin-bottom: 16px;
  }
`;

const ConditionSelected = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 17px;
  margin-bottom: 7px;
  color: ${({ theme }) => theme.grey.dark};
`;

export default Select;
